import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import APP from "./app";
import { BrowserRouter } from "react-router-dom";
import Routes from "./app/component/routes";
import Footer from './app/component/footer/Footer'

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <APP />
      <Routes />
      <Footer />
    </BrowserRouter>
  </React.StrictMode>
);
